import { Shield, Target, Users, Radar } from "lucide-react";
import { Link } from "react-router-dom";

export default function About() {
    return (
        <div className="max-w-5xl mx-auto px-4 md:px-8 py-16">
            <div className="mono-label text-volt mb-2">// MISSION BRIEF</div>
            <h1 className="font-oswald uppercase tracking-wide text-4xl md:text-5xl mb-6 leading-tight">
                Built for the ones who <span className="text-volt">wear the boots.</span>
            </h1>
            <p className="text-lg text-[#94a3b8] leading-relaxed mb-10 max-w-3xl">
                Service members earn discounts, freebies, and courtesies at thousands of merchants — but the intel is scattered, outdated, or hidden behind sign-ups. SIXCLICK maps every verified perk to a location so you can find what&apos;s near you in six clicks or less.
            </p>

            <div className="grid md:grid-cols-2 gap-4 mb-16">
                {[
                    { icon: Radar, t: "Verified & Curated", d: "Every top offer starts curated, then stays current thanks to community submissions from service members on the ground." },
                    { icon: Target, t: "Location First", d: "Search a city, ZIP, or drop a pin. We show you what's actually available where you are — not a national marketing list." },
                    { icon: Users, t: "Community-Powered", d: "Spotted a deal? Submit it. Every field report helps another family stretch their pay a little further." },
                    { icon: Shield, t: "Serves All Branches", d: "Army, Navy, Marines, Air Force, Space Force, Coast Guard — active duty, reservists, retirees, and veterans." },
                ].map((f) => (
                    <div key={f.t} className="tactical-card p-6 hud-brackets">
                        <f.icon className="w-6 h-6 text-volt mb-3" />
                        <div className="font-oswald text-xl uppercase tracking-wide mb-2">{f.t}</div>
                        <p className="text-sm text-[#94a3b8] leading-relaxed">{f.d}</p>
                    </div>
                ))}
            </div>

            <div className="tactical-card p-8 md:p-12 text-center">
                <div className="mono-label text-volt mb-3">// JOIN THE OP</div>
                <h2 className="font-oswald uppercase tracking-wide text-2xl md:text-3xl mb-4">
                    Know a discount we don&apos;t?
                </h2>
                <p className="text-[#94a3b8] mb-6 max-w-xl mx-auto">
                    Every submission helps another service member save. It takes less than two minutes.
                </p>
                <Link to="/submit" className="btn-volt inline-flex">
                    <Target className="w-4 h-4" /> Submit Intel
                </Link>
            </div>
        </div>
    );
}
